import { thirdPartyAuthStore, xoyoAuthStore } from '@src/mobx-store/root-store/auth';
import Toast from '@src/components/toast';
import reload from '@src/utils/reload';
import { computed, observable } from 'mobx';
import AccountInfoStore from '@src/components/account-info/store';
import { props } from '@src/utils/link-store';
import { px2rem } from '@src/utils/rem-util';

export default class BusinessAccountInfoStore extends AccountInfoStore {
  @computed
  get username() {
    return thirdPartyAuthStore.username || xoyoAuthStore.username;
  }

  @computed
  get xoyoAuthUsername() {
    let xoyoUsername = xoyoAuthStore.username;
    if (thirdPartyAuthStore && thirdPartyAuthStore.loginType === 'passport') {
      xoyoUsername = thirdPartyAuthStore.username;
    }
    return xoyoUsername;
  }

  /**
   * 当 xoyo 登录存在时, 同时没有第三方登录
   * @type {boolean}
   */
  @observable isAllowLogout = !!xoyoAuthStore.username && !thirdPartyAuthStore.username;

  @observable
  onLoginSuccess() {
    reload();
  }

  @observable
  onLogoutSuccess() {
    Toast.success('登出成功');
    reload();
  }

  @props
  style = {
    position: 'absolute',
    top: px2rem('40px'),
    right: px2rem('40px')
  };
}
